/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Index_Link_AllocationsInputs */

const en_admin_resources_index_link_allocations = /** @type {(inputs: Admin_Resources_Index_Link_AllocationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocations`)
};

const de_admin_resources_index_link_allocations = /** @type {(inputs: Admin_Resources_Index_Link_AllocationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuweisungen`)
};

const es_admin_resources_index_link_allocations = /** @type {(inputs: Admin_Resources_Index_Link_AllocationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asignaciones`)
};

const fr_admin_resources_index_link_allocations = /** @type {(inputs: Admin_Resources_Index_Link_AllocationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attributions`)
};

/** @type {(inputs: Admin_Resources_Index_Link_AllocationsInputs) => LocalizedString} */
const it_admin_resources_index_link_allocations = en_admin_resources_index_link_allocations;

/** @type {(inputs: Admin_Resources_Index_Link_AllocationsInputs) => LocalizedString} */
const pt_br2_admin_resources_index_link_allocations = en_admin_resources_index_link_allocations;

/** @type {(inputs: Admin_Resources_Index_Link_AllocationsInputs) => LocalizedString} */
const pl_admin_resources_index_link_allocations = en_admin_resources_index_link_allocations;

/** @type {(inputs: Admin_Resources_Index_Link_AllocationsInputs) => LocalizedString} */
const hu_admin_resources_index_link_allocations = en_admin_resources_index_link_allocations;

/** @type {(inputs: Admin_Resources_Index_Link_AllocationsInputs) => LocalizedString} */
const ro_admin_resources_index_link_allocations = en_admin_resources_index_link_allocations;

/**
* | output |
* | --- |
* | "Allocations" |
*
* @param {Admin_Resources_Index_Link_AllocationsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_index_link_allocations = /** @type {((inputs?: Admin_Resources_Index_Link_AllocationsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Index_Link_AllocationsInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_index_link_allocations(inputs)
	if (locale === "de") return de_admin_resources_index_link_allocations(inputs)
	if (locale === "es") return es_admin_resources_index_link_allocations(inputs)
	if (locale === "fr") return fr_admin_resources_index_link_allocations(inputs)
	if (locale === "it") return it_admin_resources_index_link_allocations(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_index_link_allocations(inputs)
	if (locale === "pl") return pl_admin_resources_index_link_allocations(inputs)
	if (locale === "hu") return hu_admin_resources_index_link_allocations(inputs)
	return ro_admin_resources_index_link_allocations(inputs)
});
export { admin_resources_index_link_allocations as "admin.resources.index_link_allocations" }